import { render, staticRenderFns } from "./MoveDragHandleArea.vue?vue&type=template&id=8fa03432&scoped=true&"
import script from "./MoveDragHandleArea.vue?vue&type=script&lang=ts&"
export * from "./MoveDragHandleArea.vue?vue&type=script&lang=ts&"
import style0 from "./MoveDragHandleArea.vue?vue&type=style&index=0&id=8fa03432&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fa03432",
  null
  
)

export default component.exports